module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/62.62ccf7d3.png";